import type { Leveled } from 'commonTypes'

/**
 * Get the highest amount of Genomate Score from the specified item list.
 *
 * @param {Array} itemList - List of items
 * @returns Highest amount of Genomate Score from item list
 */
export const getMaxGenomateScoreFromLeveledList = (
    itemList: Leveled[]
): number => {
    return itemList.reduce((maxValue: number, currentItem: Leveled) => {
        return Math.max(maxValue, currentItem.level)
    }, 0)
}

/**
 * Get the lowest amount of Genomate Score from the specified item list.
 *
 * @param {Array} itemList - List of items
 * @returns Lowest amount of Genomate Score from item list
 */
export const getMinGenomateScoreFromLeveledList = (
    itemList: Leveled[]
): number => {
    return itemList.reduce((minValue: number, currentItem: Leveled) => {
        return Math.min(minValue, currentItem.level)
    }, 0)
}

/**
 * Sorts items based on their level in descending order.
 *
 * @param {Array<{level: number}>} items - Array of objects with level property
 * @returns {Array<{level: number}>} - sorted items
 */
export const sortByLevelDescending = <T extends { level: number }>(
    items: T[]
): T[] => {
    return items.sort((a, b) => b.level - a.level)
}

/**
 * Sorts items based on their level in ascending order.
 *
 * @param {Array<{level: number}>} items - Array of objects with level property
 * @returns {Array<{level: number}>} - sorted items
 */
export const sortByLevelAscending = <T extends { level: number }>(
    items: T[]
): T[] => {
    return items.sort((a, b) => a.level - b.level)
}
